import { toast } from "sonner";

import { api } from "@/lib/api";
import type { EnvioAprovacao } from "@/types";

/**
 * PDF gerado no envio: só visualização, em nova aba. A aba abre já no clique —
 * depois do `await` o navegador trataria como pop-up e bloquearia — e recebe o
 * PDF quando ele chega. (`noopener` não serve: faz o `window.open` devolver null.)
 */
export async function abrirPdf(envio: Pick<EnvioAprovacao, "id">) {
  const aba = window.open("", "_blank");
  if (!aba) {
    toast.error("O navegador bloqueou a nova aba — libere pop-ups para este site.");
    return;
  }
  aba.opener = null;
  try {
    const blob = await api<Blob>(`/aprovacoes/${envio.id}/pdf`, { blob: true });
    const url = URL.createObjectURL(blob);
    aba.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (erro) {
    aba.close();
    toast.error(erro instanceof Error ? erro.message : "Não foi possível abrir o PDF.");
  }
}
